jQuery(function ( $ ) {
	$(document).on('change', '.js-user-answer-do', function () {
		if( $(this).prop('checked') ) {
			$(this).closest('.poll_text').focus();
		}
		return false;
	});


	// Когда выбран пользовательский вариант
	$(document).on('click', '.js-user-answer-poll', function () {
		$(this).closest('.poll_itm__answer').find('input').prop('checked', true);
		if( typeof init_checkbox_style === 'function' ) {
			init_checkbox_style();
		}

		if( typeof init_radio_style === 'function' ) {
			init_radio_style();
		}
	});

	// Развернуть опрос, если в нем больше одного вопроса
	$(document).on('click', '.js-open-all-questions', function () {

		$(this).toggleClass('open');

		if( $(this).hasClass('open') ) {
			$(this).text($(this).attr('date-close'));
		} else {
			$(this).text($(this).attr('date-full'));
		}

		$(this).closest('.poll_itm').find('.poll_itm__question').not(':first-child').slideToggle(300);
		$(this).closest('.poll_itm').find('.poll_itm__btn').toggle(300);
		return false;
	});


	$(document).on('submit', '.js-poll-form', function () {
		let self   = $(this),
		    params = $(this).serialize() + '&action=poll_vote',
		    err    = false;

		self.parent().find('.error').remove();

		self.find('.b_poll_answers').each(function () {
			if( $(this).find('input:checked').size() < 1 && $(this).find('input[type="text"]').size() < 1 || $(this).find('input[type="text"]').val() == '' ) {
				self.before('<p class="error">Нужно выбрать хотя бы одно значение в вопросе.</p>');
				err = true;
				return false;
			}
		});

		if( !err ) {
			$.ajax({
				type   : 'POST',
				url    : window.wp_polls.ajax_url,
				data   : params,
				success: function ( res ) {
					let data = JSON.parse(res.data);

					if( data.cookie ) {
						console.log(data.cookie);
						set_cookie('pollsvote', data.cookie);
					}

					if( data.error ) {
						self.before(data.error);
					}

					if( data.cont ) {
						self.after(data.cont);
						self.remove();
					}

				}
			});

		}

		return false;
	});

	function get_cookie( name ) {
		let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
		return matches ? decodeURIComponent(matches[1]) : undefined;
	}

	//сохранить куки
	function set_cookie( name, value, expires ) {  // имя cookie, значение
		if( !expires ) {
			expires = new Date(); // получаем текущую дату
			expires.setTime(expires.getTime() + (1000 * 86400 * 365)); // вычисляем срок хранения cookie

		}
		document.cookie = name + "=" + encodeURIComponent(value) + "; expires=" + expires.toGMTString() + "; path=/";
	}

});